import { Col, Row } from "react-bootstrap";
import ServiceSurchargeSection from "../../../../Customer/Service/ServiceSurchargeSection";
import CreateService from "./CreateService";


const ServiceSurcharge = () => {

  return (
    <>
      {/* Service surcharge section*/}
      <Row className="mb-2 mt-2">
        <Col sm={12}>
          <div className="section_action_btn">
            <CreateService />
          </div>
          {/* table */}
        </Col>
      </Row>
      <ServiceSurchargeSection />
    </>
  );
}
export default ServiceSurcharge;